import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LicenceBandComponent } from "./pages/licence/licence-band/licence-band.component";
import { LicenceCountryComponent } from "./pages/licence/licence-country/licence-country.component";
import { LicenceCountryBandComponent } from "./pages/licence/licence-country-band/licence-country-band.component";
import { LicenceBandgroupComponent } from "./pages/licence/licence-bandgroup/licence-bandgroup.component";
import { AwardsComponent } from "./pages/awards/awards.component";
import { AwardsBandgroupComponent } from "./pages/awards/awards-bandgroup/awards-bandgroup.component";
import { AwardsBandComponent } from "./pages/awards/awards-band/awards-band.component";
import { AwardsCountryComponent } from "./pages/awards/awards-country/awards-country.component";
import { AwardsCountryBandComponent } from "./pages/awards/awards-country-band/awards-country-band.component";
import { AwardsDetailsComponent } from "./pages/awards/awards-details/awards-details.component";
import { LicenceCountryBandgroupComponent } from "./pages/licence/licence-country-bandgroup/licence-country-bandgroup.component";
import { AwardsCountryBandgroupComponent } from "./pages/awards/awards-country-bandgroup/awards-country-bandgroup.component";
import { LicenceComponent } from "./pages/licence/licence.component";
import { AboutComponent } from "./pages/about/about.component";
import { ErrorComponent } from "./pages/error/error.component";
import { UpgradeComponent } from "./pages/upgrade/upgrade.component";
import { UpcomingComponent } from "./pages/reports/upcoming/upcoming.component";
import { AuthGuard } from "./shared/auth/auth.guard";
import { OperatorsComponent } from "./pages/reports/operators/operators.component";

const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceComponent,
    pathMatch: "full",
  },
  {
    path: "licences",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceComponent,
    pathMatch: "full",
  },
  {
    path: "licences/band/:bandCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceBandComponent,
  },
  {
    path: "licences/country/:countryCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceCountryComponent,
  },
  {
    path: "licences/country/:countryCode/band/:bandCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceCountryBandComponent,
  },
  {
    path: "licences/country/:countryCode/bandGroup/:bandGroup",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceCountryBandgroupComponent,
  },
  {
    path: "licences/bandGroup/:bandGroup",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: LicenceBandgroupComponent,
  },
  {
    path: "awards",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsComponent,
  },
  {
    path: "awards/bandGroup/:bandGroup",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsBandgroupComponent,
  },
  {
    path: "awards/band/:bandCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsBandComponent,
  },
  {
    path: "awards/country/:countryCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsCountryComponent,
  },
  {
    path: "awards/country/:countryCode/band/:bandCode",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsCountryBandComponent,
  },
  {
    path: "awards/country/:countryCode/bandGroup/:bandGroup",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsCountryBandgroupComponent,
  },
  {
    path: "awards/:awardKey",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AwardsDetailsComponent,
  },
  {
    path: "about",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: AboutComponent,
  },
  {
    path: "upgrade",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: UpgradeComponent,
  },
  {
    path: "reports/upcoming",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: UpcomingComponent,
  },
  {
    path: "reports/operators",
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    component: OperatorsComponent,
  },
  {
    path: "accessDenied",
    component: UpgradeComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always",
    data: {
      error: "403",
      errorMessage: "Access Denied",
    },
  },
  {
    path: "404",
    component: ErrorComponent,
  },
  {
    path: "**",
    redirectTo: "/404",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
